import axios from '@/plugins/axios'
import localforage from 'localforage'
import jwtDecode from 'jwt-decode'

const state = {
  currentUser: null
}

const getters = {
  loggedIn (state) {
    return !!state.currentUser
  },

  isAdmin (state) {
    return state.currentUser && state.currentUser.role === 'admin'
  },

  currentUser (state) {
    return state.currentUser
  },

  courses (state) {
    if (state.currentUser !== null) {
      return state.currentUser.courses
    } else {
      return null
    }
  }
}

const mutations = {
  SET_USER (state, user) {
    state.currentUser = user
  },
  REMOVE_USER (state) {
    state.currentUser = null
  }
}

const actions = {
  logIn ({ commit }, { email, password }) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/v1/firebase_token', {
          email, password
        })
        .then(response => {
          const token = response.data.token
          const jwtData = jwtDecode(token)
          const user = {
            email: email,
            ...jwtData.claims
          }

          localforage.setItem('currentUser', user)
          commit('SET_USER', user)
          resolve(token)
        })
        .catch(error => reject(error))
    })
  },

  signOut ({ commit }) {
    localforage.setItem('currentUser', null)
    commit('SET_USER', null)
  },

  setUser ({ commit }, user) {
    commit('SET_USER', user)
  },

  removeUser ({ commit }) {
    commit('REMOVE_USER')
  }
}

const namespaced = true

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}
